import {
  HttpRequest,
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpErrorResponse,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { Injectable, Provider } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ShapeInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.status === 403 &&
          error.error?.errorCode &&
          error.error?.errorCode === 'BLOCK0001'
        ) {
          // stuff
          this.router.navigate(['/block'], {
            queryParams: { supportId: error.error?.errorId },
          });
        }

        // You can perform error logging, show notifications, etc.
        return throwError(() => error); // Re-throw the error for further handling
      }),
    );
  }
}

export function shapeProvider(): Provider[] {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ShapeInterceptor,
      multi: true,
    },
  ];
}
